import { createReducer } from '@reduxjs/toolkit';
import { getLtiPlatforms, getManageXRToken, registerLtiPlatform, updateLtiPlatform } from '../actions/admin';
import { PlatformParameters } from 'ltijs';

export interface State {
  hasError: boolean;
  errorMessage: string | null;
  fetchingLtiPlatforms: boolean;
  updatingLtiPlatform: boolean;
  ltiPlatforms: PlatformParameters[];
  fetchingManageXRToken: boolean;
  manageXRTokens: { [studentId: number]: string };
}

const initialState: State = {
  hasError: false,
  errorMessage: null,
  fetchingLtiPlatforms: false,
  updatingLtiPlatform: false,
  ltiPlatforms: [],
  fetchingManageXRToken: false,
  manageXRTokens: {},
};

const setErrorState = (state: State, action) => {
  state.hasError = true;
  if (action.payload) {
    state.errorMessage = action.payload.message;
  } else if (action.error && action.error?.message) {
    // Error thrown locally
    console.error(`Redux Error for ${action.type}`, action.error);
    state.errorMessage = action.error.message;
  } else {
    state.errorMessage = 'Unknown error.';
  }
};

export default createReducer<State>(initialState, (builder) =>
  builder
    .addCase(getLtiPlatforms.pending, (state) => {
      state.fetchingLtiPlatforms = true;
      state.ltiPlatforms = [];
    })
    .addCase(getLtiPlatforms.fulfilled, (state, action) => {
      state.ltiPlatforms = action.payload;
      state.fetchingLtiPlatforms = false;
    })
    .addCase(registerLtiPlatform.pending, (state) => {
      state.fetchingLtiPlatforms = true;
    })
    .addCase(registerLtiPlatform.fulfilled, (state, action) => {
      state.fetchingLtiPlatforms = false;
      const p: PlatformParameters[] = [];
      let update = true;
      for (const platform of state.ltiPlatforms) {
        if (action.payload.url == platform.url && action.payload.clientId == platform.clientId) {
          p.push(action.payload);
          update = false;
        } else {
          p.push(platform);
        }
      }
      if (update) p.push(action.payload);
      state.ltiPlatforms = p;
    })
    .addCase(updateLtiPlatform.pending, (state) => {
      state.updatingLtiPlatform = true;
    })
    .addCase(updateLtiPlatform.fulfilled, (state, action) => {
      for (const platform of state.ltiPlatforms) {
        if (action.payload.id == platform.id) {
          platform.active = action.payload.active;
        }
      }
      state.updatingLtiPlatform = false;
    })
    .addCase(getManageXRToken.pending, (state) => {
      state.fetchingManageXRToken = true;
      state.ltiPlatforms = [];
    })
    .addCase(getManageXRToken.fulfilled, (state, action) => {
      const { token, userId } = action.payload;
      state.manageXRTokens[userId] = token;
      state.fetchingManageXRToken = false;
    })
    .addCase(getManageXRToken.rejected, (state, action) => {
      setErrorState(state, action);
      state.fetchingManageXRToken = false;
    }),
);
